const Index = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/Index.vue')
const Dashboard = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/Dashboard.vue')
const PantauBelanja = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/PantauBelanja.vue')
const PantauAnggaran = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/PantauAnggaran.vue')
const Mendaftar = () =>
  import(/* webpackChunkName: "umum-register" */ '../views/Mendaftar.vue')
// const PantauAsmas = () =>
//   import(/* webpackChunkName: "umum-index" */ '../views/PantauAsmas.vue')
const AspirasiMusrenbang = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/Aspirasi/Musrenbang.vue')
const AspirasiLangsung = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/Aspirasi/Langsung.vue')
const AspirasiReses = () =>
  import(/* webpackChunkName: "umum-index" */ '../views/Aspirasi/Reses.vue')
const ForgotPassword = () =>
  import(/* webpackChunkName: "umum-auth" */ '../views/ForgotPassword.vue')
const ResetPassword = () =>
  import(/* webpackChunkName: "umum-auth" */ '../views/ResetPassword.vue')

export default [
  {
    path: 'index',
    name: 'index',
    component: Index
  },
  {
    path: 'dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: 'mendaftar',
    name: 'mendaftar',
    component: Mendaftar
  },
  {
    path: 'pantau-belanja',
    name: 'pantau_belanja',
    component: PantauBelanja
  },
  {
    path: 'pantau-anggaran',
    name: 'pantau_anggaran',
    component: PantauAnggaran
  },
  // {
  //   path: 'pantau-asmas',
  //   name: 'pantau_asmas',
  //   component: PantauAsmas
  // },
  {
    path: 'asmas-musrenbang',
    name: 'asmas_musrenbang',
    component: AspirasiMusrenbang
  },
  {
    path: 'asmas-langsung',
    name: 'asmas_langsung',
    component: AspirasiLangsung
  },
  {
    path: 'asmas-reses',
    name: 'asmas_reses',
    component: AspirasiReses
  },
  {
    path: 'password',
    name: 'forgotPassword',
    component: ForgotPassword
  },
  {
    path: 'password/reset/:token',
    name: 'resetPassword',
    component: ResetPassword,
    props: true
  }
]
